import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
} from "reactstrap";
import { removeFromCart, updateQuantity } from "../../slices/cart/CartSlice";
import OtpVerification from "./OtpVerification";

const CartModal = ({ isOpen, toggle, orgInfo }) => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.Cart.items);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("CartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const calculateItemTotal = (item) => {
    return item.price * item.quantity;
  };

  const total = cartItems.reduce(
    (acc, item) => acc + calculateItemTotal(item),
    0
  );

  const removeItem = (id) => {
    dispatch(removeFromCart({ itemId: id }));
  };

  const handleUpdateQuantity = (itemId, newQuantity) => {
    if (newQuantity > 0) {
      dispatch(
        updateQuantity({
          itemId,
          quantity: newQuantity,
        })
      );
    }
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleCheckout = () => {
    toggleModal();
  };

  return (
    <>
      <Offcanvas direction="end" isOpen={isOpen} toggle={toggle} className="offcanvas">
        <OffcanvasHeader toggle={toggle}>Order</OffcanvasHeader>
        <OffcanvasBody>
          {cartItems.length === 0 ? (
            <div className="text-center text-muted">Your order is empty</div>
          ) : (
            <>
              {cartItems.map((item) => {
                const itemTotal = calculateItemTotal(item);

                return (
                  <Card key={item.id} className="mb-2">
                    <CardBody>
                      <Row className="align-items-center">
                        <Col xs={4}>
                          <img
                            src={item?.displayImage?.getCDNUrl()}
                            alt={item.title}
                            className="card-image"
                          />
                        </Col>
                        <Col xs={8}>
                          <Row className="align-items-center">
                            <Col xs={12}>
                              <CardTitle tag="h6">{item.title}</CardTitle>
                              <CardText className="d-flex justify-content-between">
                                <span>NRS. {item.price}</span>
                                <span>
                                  x {item.quantity} = <strong>NRS. {itemTotal}</strong>
                                </span>
                              </CardText>
                            </Col>
                            <Col xs={12} className="d-flex justify-content-between align-items-center mt-2">
                              <div className="input-step">
                                <button
                                  type="button"
                                  className="minus bg-transparent"
                                  onClick={() => handleUpdateQuantity(item.id, item.quantity - 1)}
                                >
                                  –
                                </button>
                                <span>{item.quantity}</span>
                                <button
                                  type="button"
                                  className="plus bg-transparent"
                                  onClick={() => handleUpdateQuantity(item.id, item.quantity + 1)}
                                >
                                  +
                                </button>
                              </div>
                              <Button
                                color="danger"
                                onClick={() => removeItem(item.id)}
                                className="ms-3"
                                size="sm"
                              >
                                <i className="bx bx-trash"></i>
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                );
              })}
              <div className="total-container">
                <Row className="align-items-center">
                  <Col>
                    <h5 className="mb-0">Total:</h5>
                  </Col>
                  <Col className="text-end">
                    <h4 className="mb-0">NRS. {total.toFixed(2)}</h4>
                  </Col>
                </Row>
                <Button
                  color="primary"
                  block
                  className="checkout-btn mt-3"
                  onClick={handleCheckout}
                >
                  Checkout
                </Button>
              </div>
            </>
          )}
        </OffcanvasBody>
      </Offcanvas>

      <OtpVerification isOpen={modalOpen} toggle={toggleModal} orgInfo={orgInfo} />
    </>
  );
};

export default CartModal;